<template>
    <div id="auth" class="row">
        <div class="col col-md-4 offset-md-4 authForm">
            <h2 class="text-center"></h2>
                    <transition name="fade">
                        <router-view></router-view>
                    </transition>                    
            </div>        
    </div>
</template>

<script>

export default ({
    name: 'auth'
})
</script>

<style>
#auth {    
    height: 100%;
    display: flex;
    align-items: center;
}

.authForm{
    background: #fff;
    padding-bottom: 15px;
    padding-top: 10px;
    border-radius: 10px;
}
</style>





// WEBPACK FOOTER //
// src/components/auth/Auth.vue